const columns = [
  {
    title: '发送人',
    dataIndex: 'sendPerson',
    key: 'sendPerson',
    width: 180,
    slots: { customRender: 'sendPerson' }
  },
  {
    title: '接收人',
    dataIndex: 'receivePerson',
    key: 'receivePerson',
    width: 180,
    slots: { customRender: 'receivePerson' }
  },
  {
    title: '发送时间',
    width: 120,
    dataIndex: 'sendTime',
    key: 'sendTime'
  },
  {
    title: '发送状态',
    width: 90,
    dataIndex: 'sendStatus',
    key: 'sendStatus',
    slots: { customRender: 'sendStatus' }
  },
  {
    title: '触达状态',
    dataIndex: 'reachStatusDesc',
    key: 'reachStatusDesc',
    width: 90
  },
  {
    title: '已读情况',
    width: 90,
    dataIndex: 'readStatusDesc',
    key: 'readStatusDesc'
  },
  {
    title: '发送类型',
    dataIndex: 'sendTypeSnapshot',
    width: 200,
    key: 'sendTypeSnapshot'
  },
  {
    title: '关联工单',
    dataIndex: 'mainRelatedWorkOrder',
    width: 150,
    key: 'mainRelatedWorkOrder',
    slots: { customRender: 'mainRelatedWorkOrder' }
  },
  {
    title: '失败原因',
    dataIndex: 'sendStatusDesc',
    width: 200,
    key: 'sendStatusDesc'
  },
  {
    title: '短信详情',
    dataIndex: 'smsInfo',
    key: 'smsInfo',
    width: 300,
    slots: { customRender: 'smsInfo' }
  }
]
// 接收人/发送人
const OPERATED_PERSON = [
  { value: 'all', label: '全部' },
  { value: 'receive', label: '接收人' },
  { value: 'send', label: '发送人' }
]
export { columns, OPERATED_PERSON }
